<template>
    <div class="relative">
        <virtual-colleague-navigation />
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'VirtualColleague',
    }
</script>

<style scoped>

</style>